<template>
  <div style="padding: 10px 14px">
    <h3>教育课程云服务协议</h3>
    <p>更新及生效日期：2025年10月1日</p>
    <p>
      <strong>重要提示：请您仔细阅读本协议后再进行登录操作。如您不同意本协议的任何条款，请立即停止登录和使用服务。</strong>
    </p>

    <strong>
      <p>第一章 总则</p>
    </strong>
    <p>第一条 本协议是您与东莞市安道光电材料制造有限公司（以下简称“安道教育”或“我们”）就登录、使用教育课程云（以下简称"本平台"）所订立的协议。</p>
    <p>第二条 当您通过账号登录本平台时，即表示您已充分阅读、理解并接受本协议的全部内容，并同意受其约束。</p>
    <p>第三条 我们有权修改本协议，修改后的协议将在本平台公布后生效。如您继续使用本平台，即视为接受修改后的协议。</p>

    <strong>
      <p>第二章 账号使用规范</p>
    </strong>
    <p>第四条 您保证登录所使用的账号系本人/本单位合法所有，不得使用他人账号或虚假账号登录。</p>
    <p>
      第五条
      <strong>您应妥善保管账号及密码，并对通过该账号进行的所有活动承担全部法律责任。</strong>
    </p>
    <p>第六条 如发现任何非法使用账号或安全漏洞的情况，请立即通知我们。</p>

    <strong>
      <p>第三章 服务内容</p>
    </strong>
    <p>第七条 我们通过本平台为您提供资源检索、文献查阅、知识管理等服务（以下简称"服务"）。</p>
    <p>第八条 我们保留随时变更、中断或终止部分或全部服务的权利，且不须对您或任何第三方负责。</p>

    <strong>
      <p>第四章 使用规则</p>
    </strong>
    <p>第九条 您在使用本平台时必须遵守中华人民共和国相关法律法规，不得利用本平台从事违法违规活动，包括但不限于：</p>
    <p>（一）侵犯他人知识产权或其他合法权益；</p>
    <p>（二）传输或传播计算机病毒、恶意代码；</p>
    <p>（三）进行任何可能对平台造成不合理负荷的操作；</p>
    <p>（四）其他违反法律法规的行为。</p>
    <p>
      第十条
      <strong>如您违反上述规定，我们有权立即终止提供服务，并保留追究法律责任的权利。</strong>
    </p>

    <strong>
      <p>第五章 知识产权</p>
    </strong>
    <p>第十一条 本平台的所有知识产权，包括但不限于软件、界面、内容等，均归我们或相关权利人所有。</p>
    <p>第十二条 您通过本平台获取的任何内容，仅限个人学习研究使用，不得用于商业用途。</p>

    <strong>
      <p>第六章 免责声明</p>
    </strong>
    <p>
      第十三条
      <strong>我们不对以下情况承担责任：</strong>
    </p>
    <p>（一）因不可抗力导致的服中断；</p>
    <p>（二）因您自身原因造成的账号泄露或损失；</p>
    <p>（三）非我们所能控制的原因造成的服务中断或缺陷。</p>

    <strong>
      <p>第七章 隐私保护</p>
    </strong>
    <p>第十四条 我们将按照《隐私政策》保护您的个人信息，请在登录前仔细阅读该政策。</p>

    <strong>
      <p>第八章 法律适用与争议解决</p>
    </strong>
    <p>第十五条 本协议的订立、执行和解释适用中华人民共和国法律。</p>
    <p>第十六条 因本协议引起的任何争议，双方应友好协商解决；协商不成的，任何一方均可向我们所在地人民法院提起诉讼。</p>

    <strong>
      <p>第九章 其他规定</p>
    </strong>
    <p>第十七条 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>
    <p>第十八条 本协议自您登录本平台之日起生效。</p>

    <p>
      <strong>联系我们</strong>
    </p>

    <P>如果您对本协议有任何疑问，请联系：</P>
    <P>公司：{{ activationCompany.company }}</P>
    <P>电话：400-632-8880</P>
    <P>联系人：客服专员</P>
    <P>地址：{{ activationCompany.address }}</P>
    <p>
      <strong>再次提醒：登录操作即代表您已阅读、理解并同意接受本协议所有条款的约束。</strong>
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activationCompany: {
        company: '东莞市安道光电材料制造有限公司',
        address: '广东省东莞市松山湖国际金融园C区11栋A座',
        abbreviation: '安道'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
h3 {
  font-size: 16px;
  text-align: center;
}

p {
  font-size: 14px;
}
</style>
